import React, { ChangeEvent } from "react";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import { Box, FormControlLabel, Grid, Radio, RadioGroup } from "@material-ui/core";
import { FormattedMessage, useIntl } from "react-intl";
import InputTextField from "./TextField";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    titleBig: {
      marginBottom: 2,
      height: "31px",
      fontSize: "22px",
      fontWeight: 600,
      lineHeight: "31px",
      color: "#333333",
      textAlign: "left",
    },
    optionText: {
      fontSize: "14px",
      color: "#333333",
      lineHeight: "22px",
    },
    notice: {
      color: "#8b1f1f",
      fontSize: "14px",
      lineHeight: "22px",
      fontWeight: 600,
      padding: "4px 0",
    },
    fieldRow: {
      marginTop: "18px",
    },
  })
);

interface IProps {
  formState: any;
  handleFormChange: (e: ChangeEvent<HTMLInputElement>) => any;
}

const CartTransport: React.FC<IProps> = ({ formState, handleFormChange }) => {
  const classes = useStyles();
  const intl = useIntl();

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={12} className={classes.titleBig}>
        <FormattedMessage id="cart.transport" />
      </Grid>
      <Grid item xs={12} md={12}>
        <RadioGroup
          name="transportType"
          onChange={handleFormChange}
          value={formState.transportType}
        >
          <FormControlLabel
            value="PICKUP"
            id="pickup"
            control={<Radio />}
            label={intl.formatMessage({ id: "transport.pickup" })}
          />
          <Box pl={4} pb={2} className={classes.optionText}>
            Jelgavas iela 28, Rīga, LV-1004
          </Box>
          <FormControlLabel
            value="DELIVERY"
            id="delivery"
            control={<Radio />}
            label={intl.formatMessage({ id: "transport.delivery" })}
          />
        </RadioGroup>
      </Grid>
      {formState.transportType === "DELIVERY" ? (
        <>
          <Grid item xs={12} md={12} className={classes.fieldRow}>
            <Box className={classes.notice}>
              <FormattedMessage id="transport.deliveryPriceNotice" />
            </Box>
          </Grid>
          <Grid item xs={12} md={12}>
            <InputTextField
              name="deliveryAddress"
              title={intl.formatMessage({ id: "profile.deliveryAddress" })}
              value={formState.deliveryAddress || ""}
              formChange={handleFormChange}
            />
          </Grid>
        </>
      ) : null}
      <Grid item xs={12} md={12} className={classes.fieldRow}>
        <InputTextField
          name="notes"
          title={intl.formatMessage({ id: "cart.notes" })}
          value={formState.notes || ""}
          formChange={handleFormChange}
        />
      </Grid>
    </Grid>
  );
};

export default CartTransport;
